import React, { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const DashNav = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const containerRef = useRef(null)
  const itemRefs = useRef([])
  const firstRender = useRef(true)

  const items = [
    { name: 'Mine bøger', link: 'bøger' },
    { name: 'Mine ordrer', link: 'ordrer' },
    { name: 'Saldo', link: 'saldo' },
    { name: 'Profil', link: 'profil' },
  ]

  const loopCount = 5
  const midOffset = items.length * 2 // Midterste sæt (tredje sæt)

  // Vi laver 5 sæt af items
  const visibleItems = Array(loopCount).fill(items).flat()

  const activePath = decodeURIComponent(location.pathname).toLowerCase()

  // Scroll til midten første gang uden animation
  useEffect(() => {
    const container = containerRef.current
    const middleIndex = midOffset + items.findIndex(
      (item) => `/dashboard/${item.link}` === activePath || `/dashboard${item.link}` === activePath || `/dashboard/${item.link}/` === activePath
    )
    const el = itemRefs.current[middleIndex]

    if (el && container) {
      const center = container.offsetWidth / 2

      // Første render uden animation
      if (firstRender.current) {
        container.scrollTo({
          left: el.offsetLeft - center + el.offsetWidth / 2,
          behavior: 'instant', // Ingen animation
        })
        firstRender.current = false
      }
    }
  }, [])

  function smoothScrollTo(element, position) {
    return new Promise((resolve) => {
      element.scrollTo({ left: position, behavior: 'smooth' });
  
      let lastScrollLeft = element.scrollLeft;
      let sameCount = 0;
  
      function checkIfDone() {
        const currentScrollLeft = element.scrollLeft;
  
        if (Math.abs(currentScrollLeft - lastScrollLeft) < 1) {
          sameCount++;
        } else {
          sameCount = 0;
          lastScrollLeft = currentScrollLeft;
        }
  
        if (sameCount > 5) {
          setTimeout(resolve, 0);
        } else {
          requestAnimationFrame(checkIfDone);
        }
      }
  
      checkIfDone();
    });
  }  

  const handleClick = async (e) => {
    console.log(activePath)
    const container = containerRef.current
    let el = itemRefs.current[Number(e.target.id)]

    if (el && container) {

      const scrollLeft = container.scrollLeft
      const scrollWidth = container.scrollWidth
      const containerWidth = container.offsetWidth

      // Beregn tredjedel af det samlede scrollbare område
      const third = (scrollWidth - containerWidth) / loopCount
      const center = container.offsetWidth / 2

      await smoothScrollTo(container, el.offsetLeft - center + el.offsetWidth / 2)

      const middleIndex = midOffset + items.findIndex(
        (item) => item === visibleItems[Number(e.target.id)]
      )
      el = itemRefs.current[middleIndex]

      container.scrollTo({
        left: el.offsetLeft - center + el.offsetWidth / 2,
        behavior: 'instant', // Smooth scroll ved navigation
      })
    }
  }

  return (
    <div className="flex justify-between text-xl font-medium">
      <div
        ref={containerRef}
        className="flex gap-8 overflow-x-auto no-scrollbar w-full relative lg:hidden"
      >
        {visibleItems.map((item, i) => {
          const isActive = `/dashboard/${item.link}` === activePath || `/dashboard${item.link}` === activePath || `/dashboard/${item.link}/` === activePath
          return (
            <div
              key={`${item.link}-${i}`}
              id={i}
              ref={(el) => (itemRefs.current[i] = el)}
              className={`shrink-0 px-4 cursor-pointer hover:text-black transition-[] ${
                isActive ? 'text-black scale-[125%]' : 'text-neutral-500'
              }`}
              onClick={(e) => navigate(`/dashboard/${item.link}`) & handleClick(e)}
            >
              {item.name}
            </div>
          )
        })}
      </div>
      <div className="gap-8 w-full relative hidden lg:flex -ml-4">
        {items.map((item, i) => {
          const isActive = `/dashboard/${item.link}` === activePath || `/dashboard${item.link}` === activePath || `/dashboard/${item.link}/` === activePath
          return (
            <div
              key={`${item.link}-${i}`}
              className={`shrink-0 px-4 cursor-pointer hover:text-black transition-[] ${
                isActive ? 'text-black' : 'text-neutral-500'
              }`}
              onClick={(e) => navigate(`/dashboard/${item.link}`)}
            >
              {item.name}
            </div>
          )
        })}
      </div>
    </div>
  )
}